
import Vue, { PropType } from 'vue';
import { get } from 'lodash';

export default Vue.extend({
    name: 'Translations',

    props: {
        labels: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        },
        config: {
            type: Object as PropType<Record<string, unknown>>,
            default: () => ({})
        }
    },

    computed: {
        src(): string {
            return get(this, 'config.src');
        },

        hidden(): boolean {
            return get(this, 'config.hidden');
        }
    }
});
